var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.002C0 7.16545 7.1635 0.00195312 16 0.00195312C24.8365 0.00195312 32 7.16545 32 16.002C31.3044 16.002 16 18.0889 16 18.0889L0 16.002Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.002C32 24.8385 24.8365 32.002 16 32.002C7.1635 32.002 0 24.8385 0 16.002",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 10.4368L17.2084 14.1566H21.1201L17.9556 16.4558L19.1642 20.1759L15.9998 17.8768L12.8354 20.1759L14.0442 16.4558L10.8796 14.1566H14.7911L15.9998 10.4368Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBf);
export default __webpack_public_path__ + "static/media/BF.2ac3640d.svg";
export { ForwardRef as ReactComponent };